module.exports = __webpack_public_path__ + "img/KK0043C-PI.0723fb5d.jpg";